{
  "app": {
    "name": "منتهى الإنجاز",
    "tagline": "نظام الحجوزات",
    "taglineLong": "نظام إدارة الحجوزات",
    "title": "منتهى الإنجاز · نظام الحجوزات"
  },
  "actions": {
    "retry": "إعادة المحاولة",
    "back": "تراجع",
    "working": "جارٍ التنفيذ…",
    "download": "تحميل",
    "change": "تغيير",
    "home": "العودة للرئيسية"
  },
  "loading": "جاري التحميل",
  "pagination": {
    "label": "الصفحات",
    "showing": "عرض {{from}}–{{to}} من {{total}}",
    "previous": "السابق",
    "next": "التالي"
  },
  "file": {
    "onlyTypes": "المسموح: PDF أو JPG أو PNG فقط",
    "tooLarge": "حجم الملف يتجاوز 10MB",
    "dropHere": "اسحب الملف هنا أو اختر من جهازك",
    "typesHint": "PDF أو JPG أو PNG · حتى 10MB",
    "previewFailed": "تعذر عرض المعاينة — حمّل الملف لعرضه."
  },
  "search": {
    "global": "ابحث برقم الحجز أو اسم العميل أو الجوال",
    "globalLabel": "بحث برقم الحجز أو اسم العميل أو الجوال"
  },
  "theme": {
    "toDark": "الوضع الداكن",
    "toLight": "الوضع الفاتح"
  },
  "language": {
    "switch": "English",
    "switchLabel": "التبديل إلى الإنجليزية"
  },
  "topbar": {
    "menu": "القائمة",
    "breadcrumb": "مسار التنقل"
  },
  "agreementChip": {
    "percentage": "نسبة {{label}}",
    "fixed": "ثابت {{label}}"
  },
  "status": {
    "booking": {
      "draft": "مسودة",
      "confirmed": "مؤكد",
      "invoiced": "مفوتر",
      "paid": "مدفوع",
      "cancelled": "ملغي",
      "refunded": "مسترد"
    },
    "invoice": {
      "pending_send": "قيد الإرسال",
      "sent": "أُرسلت",
      "paid": "مدفوعة",
      "payment_failed": "فشل الدفع",
      "send_failed": "فشل الإرسال",
      "cancelled": "ملغاة",
      "expired": "منتهية الصلاحية",
      "rejected": "مرفوضة"
    },
    "commission": {
      "pending": "معلّقة",
      "earned": "مستحقة",
      "paid": "محوّلة",
      "void": "ملغاة",
      "reversed": "معكوسة"
    },
    "portal": {
      "active": "مفعّلة",
      "invited": "دعوة مرسلة",
      "none": "بدون حساب",
      "disabled": "موقوف"
    },
    "contract": {
      "active": "ساري",
      "expiring": "ينتهي قريباً",
      "expired": "منتهي",
      "no_dates": "بدون تاريخ"
    },
    "partner": {
      "active": "نشط",
      "inactive": "متوقف"
    },
    "agreement": {
      "current": "سارية حالياً",
      "scheduled": "مجدولة",
      "past": "منتهية",
      "cancelled": "ملغاة"
    },
    "signing": {
      "sent": "مرسل",
      "viewed": "تم الاطلاع",
      "signed": "موقّع",
      "expired": "انتهى الرابط",
      "cancelled": "ملغى"
    }
  },
  "errors": {
    "networkTitle": "تعذر الاتصال بالخادم",
    "networkDetail": "تحقق من اتصالك بالإنترنت ثم حاول مجدداً.",
    "server": "حدث خطأ في الخادم، حاول مرة أخرى.",
    "generic": "حدث خطأ غير متوقع",
    "fallbackTitle": "خطأ",
    "forbidden": "ليس لديك صلاحية لعرض هذه الصفحة",
    "notFound": "الصفحة غير موجودة",
    "crashed": "حدث خطأ"
  },
  "auth": {
    "agency": "وكالة منتهى الإنجاز",
    "headline": "بوابتكم نحو العالم، وحجوزاتكم في مكان واحد",
    "body": "حجوزات عبر شركائنا، فواتير تصل العميل على جواله، وعمولات منسقين محسوبة تلقائياً.",
    "pills": {
      "bookings": "حجوزات الشركاء",
      "invoices": "فواتير على الجوال",
      "billing": "فوترة StreamPay"
    }
  },
  "statusSource": {
    "app": "التطبيق",
    "webhook": "الإشعار",
    "status_api": "فحص الحالة",
    "reconcile": "المطابقة الليلية"
  },
  "statusChanged": "آخر تحديث للحالة عبر {{source}} · {{at}}",
  "signature": {
    "placeholder": "ارسم توقيعك هنا",
    "hint": "استخدم إصبعك أو الفأرة أو القلم",
    "clear": "مسح",
    "how": "طريقة التوقيع",
    "draw": "رسم",
    "upload": "رفع صورة",
    "uploadPrompt": "اختر صورة التوقيع أو اسحبها هنا",
    "uploadHint": "PNG أو JPG أو WebP حتى 5MB",
    "uploadType": "الصيغ المسموحة: PNG أو JPG أو WebP",
    "uploadSize": "حجم الصورة يتجاوز 5MB",
    "whiteRemoved": "تُزال الخلفية البيضاء تلقائياً",
    "remove": "إزالة"
  }
}
